import React from 'react';
import Elem from '../Elem/Elem';
import Loader from '../../../Loader/Loader';

const LoadingElem = (props) => (
  <Elem id="loader" key="loader" title="Loading..." value={<Loader />} {...props} />
);

export default LoadingElem;
